import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Web3 from 'web3';
import { useDropzone } from 'react-dropzone';
import './ArtUploader.css';

const ArtUploader = ({wpApiUrl, auctionContract, wpNonce}) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [artistAddress, setArtistAddress] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('');
  //const [txHash, setTxHash] = useState('');

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      setFile(acceptedFiles[0]);
      setPreview(URL.createObjectURL(acceptedFiles[0]));
    },
  });

  useEffect(() => {
    if (typeof window.ethereum === 'undefined') {
      setStatus('MetaMask is not installed');
    }
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!file) {
      setStatus('Please select a file to upload.');
      return;
    }

    if (!artistAddress) {
      setStatus('Please enter an Ethereum address.');
      return;
    }

    setStatus("Uploading...");
    const fileReader = new FileReader();
    fileReader.onload = async () => {
      const hash = Web3.utils.sha3(fileReader.result);
      const filename = `art-${hash.toString('hex')}.${file.name.split('.').pop()}`;

      try {
        if (typeof window.ethereum === 'undefined') {
          throw new Error("MetaMask is not installed");
        }

        setStatus("Checking blockchain...");
        let submission = await auctionContract.methods.getSubmission(hash).call();
        if (Number(submission.state) !== 0) {
          throw new Error("Duplicate submission, can't submit");
        }

        const formData = new FormData();
        formData.append('file', file, filename);
        formData.append('description', description);

        let headers = {};
        let auth = {};
        if (wpNonce) {
          headers['X-WP-Nonce'] = wpNonce;
        } else {
          auth = {
            username: process.env.REACT_APP_WP_USERNAME,
            password: process.env.REACT_APP_WP_APP_PASSWORD,
          }
        }

        const response = await axios.post(wpApiUrl + '/wp/v2/media', formData, {
          headers: {
            ...headers,
            'Content-Type': 'multipart/form-data',
          },
          auth,
        });

        const mediaId = response.data.id;

        // Save metadata to WordPress database
        await axios.post(wpApiUrl + '/artifex/v1/art-meta', {
          media_id: mediaId,
          hash,
          artist_address: artistAddress,
        }, {
          headers,
          auth,
        });

        setStatus("Submitting art to blockchain...");
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        if (accounts.length === 0) {
          throw new Error("No accounts found");
        }
        console.log(window.ethereum.selectedAddress);
        await auctionContract.methods.addSubmission(hash, artistAddress)
                             .send({ from: window.ethereum.selectedAddress })
                             .on('transactionHash', hash => {
                               console.log("Submit art transaction hash: " + hash);
                               setStatus("Transaction hash: " + hash);
                             })
                             .on('confirmation', (confirmationNumber, receipt) => {
                               setStatus("Transaction hash: " + String(receipt.transactionHash) + " confirmed!");
                             })
                             .catch(error => {
                               // Handle at the common catch point
                               throw error;
                             });
      } catch (error) {
        console.log(String(error));
        setStatus(String(error));
      }
    };

    fileReader.readAsBinaryString(file);
  };

  return (
    <form onSubmit={handleSubmit} className="art-uploader-form">
      <div {...getRootProps()} className="dropzone">
        <input {...getInputProps()} />
        {
          isDragActive ? <p>Drop the file here ...</p> :
          <div className="dropzone-placeholder">
            {preview ? (
              <img src={preview} alt="Preview" className="preview-image" />
            ) : (<p>Image Preview</p>)}
            <p>Drag 'n' drop or click to upload a file</p>
          </div>
        }
      </div>
      <div className="form-fields">
        <label className="form-label">
          Artist Ethereum Address:
          <input type="text" value={artistAddress} onChange={(event) => setArtistAddress(event.target.value)} required className="form-input" placeholder="Required" />
        </label>
        <br />
        <label className="form-label">
          Description:
          <textarea value={description} onChange={(event) => setDescription(event.target.value)} className="form-textarea" placeholder="Optional"/>
        </label>
        <br />
        <button type="submit" className="submit-button">Submit Art</button>
        <p className="status-message">{status}</p>
      </div>
    </form>
  );
};

export default ArtUploader;
